import { Breadcrumb } from '@/src/packages/components/ui/Breadcrumb';
import { useProductContext } from '../ProductContext';
import { getRoute } from '@/src/packages/utils/routes';
import { paths } from '@/src/packages/routes';
import { pathParams } from '@/src/packages/routes/pathParams.enum';

export const ProductBreadcrumb = () => {
  const {
    productVariant: {
      title,
      product: { range },
    },
  } = useProductContext();

  return (
    <Breadcrumb
      className="py-4"
      items={[
        ...(range
          ? [
              {
                label: range.name,
                path: getRoute({
                  route: paths.RANGES_SINGLE,
                  params: { [pathParams.RANGE_SINGLE]: range.slug },
                }),
              },
            ]
          : []),
        ...(range
          ? []
          : [
              {
                label: 'Home',
                path: getRoute({ route: paths.HOME_INDEX }),
              },
            ]),
        {
          label: title,
        },
      ]}
    />
  );
};
